import { ChargingStationConfig } from './small-biz-store.model';
import { SmallBizStoreModel } from './small-biz-store.model';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SmallBizStoreService {
  private readonly internalModel = new BehaviorSubject<SmallBizStoreModel>(SmallBizStoreService.getInitialState());

  public readonly model$ = this.internalModel.asObservable();

  public get model(): SmallBizStoreModel {
    return this.internalModel.getValue();
  }

  public set model(val: SmallBizStoreModel) {
    this.internalModel.next(val);
  }

  // mutators

  public setChargeCards(amount: number) {
    this.model = {
      ...this.model,
      chargeCardsAmount: amount,
    };
  }

  public setChargingStations(amount: number) {
    this.model = {
      ...this.model,
      chargingStationConfig: {
        ...this.model.chargingStationConfig,
        amount,
      },
    };
  }

  public setChargingStationConfig(chargingStationConfig: ChargingStationConfig) {
    this.model = {
      ...this.model,
      chargingStationConfig,
    };
  }

  public reset() {
    this.model = SmallBizStoreService.getInitialState();
  }

  // initial state

  private static getInitialState(): SmallBizStoreModel {
    return {
      chargeCardsAmount: 0,
      chargingStationConfig: {
        amount: 0,
      },
    };
  }
}
